export default __webpack_public_path__ + "static/media/ConstructorMk1.256.493652b6.png";